import { Tipo_permiso } from './../../../models/tipo_permiso.model';
import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: "page-tipo_permiso",
    templateUrl: "./tipo_permiso.component.html",
    styleUrls: ["./tipo_permiso.component.css"]
})

export class Tipo_permisoComponent {
    public rows = [];
    public actualRow;
    public tipo_permiso: Tipo_permiso;
    public form;
    constructor(){

        this.form = new FormGroup({
            obra: new FormControl('', Validators.required),
            loteo_dfl:new FormControl('', Validators.required),
            loteo_const :new FormControl('', Validators.required),
            ampliacion :new FormControl('', Validators.required),
            alteracion :new FormControl('', Validators.required),
            reparacion :new FormControl('', Validators.required),
            reconstruccion :new FormControl('', Validators.required)
        })

        if(!JSON.parse(localStorage.getItem("tipo_permiso"))){
            localStorage.setItem("tipo_permiso", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("tipo_permiso"));
            this.form.controls['obra'].setValue(this.rows[0]?this.rows[0].obra:'')
            this.form.controls['loteo_dfl'].setValue(this.rows[0]?this.rows[0].loteo_dfl:'')
            this.form.controls['loteo_const'].setValue(this.rows[0]?this.rows[0].loteo_const:'')
            this.form.controls['ampliacion'].setValue(this.rows[0]?this.rows[0].ampliacion:'')
            this.form.controls['alteracion'].setValue(this.rows[0]?this.rows[0].alteracion:'')
            this.form.controls['reparacion'].setValue(this.rows[0]?this.rows[0].reparacion:'')
            this.form.controls['reconstruccion'].setValue(this.rows[0]?this.rows[0].reconstruccion:'')
        }
        this.tipo_permiso = {obra:'',loteo_dfl:'',loteo_const:'', ampliacion:'',alteracion:'',reparacion:'',reconstruccion:'' };
    }

    add_tipo_permiso(){
        localStorage.setItem("tipo_permiso",JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_permiso");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            obra: this.form.value.obra, 
            loteo_dfl: this.form.value.loteo_dfl,
            loteo_const: this.form.value.loteo_const,
            ampliacion: this.form.value.ampliacion, 
            alteracion: this.form.value.alteracion, 
            reparacion: this.form.value.reparacion, 
            reconstruccion: this.form.value.reconstruccion
       })
        localStorage.setItem("tipo_permiso", JSON.stringify(this.rows));
    }
  
    delete_tipo_permiso(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_permiso", JSON.stringify(this.rows));
            }
        }
    }   
}